import { useEffect, useState } from 'react';
import { DateConvert } from '../utils/dateConverter';
import { Box, FormControl, InputLabel, Typography, Input, Grid, NativeSelect, Button, FormHelperText } from "@mui/material";
import SearchSelect from '../components/searchAndSelect';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { showloader, transactionClicked } from '../store/gloabalState';
import TransactionFileUpload from '../components/TransactionFileUpload';
import {  
    getOrgsDetails,
    getTransactionsDetail,
    updateTransactionRes
} from '../services/httpCalls';
import DroppedStage from "../components/DroppedStage";
import { gstRegex, inwardStages, onlyNumericDigitsWithDecimalRegex, utrRegex } from '../config/globalVar';
import useNotify from '../utils/useNotify';
import { useNavigate } from 'react-router-dom';
import { cleanObject } from '../utils/onboarding/clean-object';

const UpdateInwardTransaction = () => {

    // local states
    const [type, setType] = useState(""); 
    const [fundReqBank, setFundReqBank] = useState("");
    const [adBankdetails, setAdBankdetails] = useState([]);
    const [transactionDetail, setTransactionDetail] = useState();
    const [showDroppedTxnModal, setShowDroppedTxnModal] = useState(false);
    const [updateForm, setUpdateForm] = useState({});
    const [errors, setErrors] = useState({
        netInr: false,
        utr:false,
        gstAmount: false,
        commissionCharges: false
    });

    // global states

    // values

    // setter/updater
    const setShowLoader = useSetRecoilState(showloader)

    // states
    const [transactionId, setTransactionId] = useRecoilState(transactionClicked)

    // constants/binders
    const notify = useNotify();
    const navigate = useNavigate();

    const updateTransactionCall = (e) => {
        e.preventDefault();
        let finalForm = updateForm

        if(updateForm?.netInrReceived && (updateForm.netInrReceived < 0 || updateForm.netInrReceived.length > 13)){
            setErrors((err) => ({
                ...err,
                netInr: true
            }))
            return;
        } 
        if(updateForm?.utr && (updateForm.utr.length > 13 || updateForm.utr < 0)){
            setErrors((err) => ({
                ...err,
                utr: true
            }))
            return;
        }
        if(updateForm?.gstAmount && (updateForm.gstAmount.length > 13 || updateForm.gstAmount < 0)){
            setErrors((err) => ({
                ...err,
                gstAmount: true
            }))
            return;
        }
        if(updateForm?.commissionCharges && (updateForm.commissionCharges.length > 13 || updateForm.commissionCharges < 0)){
            setErrors((err) => ({
                ...err,
                commissionCharges: true
            }))
            return;
        }

        if(Object.values(errors).some(error => error === true)){
            return;
        }

        setShowLoader(true);

        finalForm = {
            ...finalForm,
            payout : {
                amount: finalForm.netInrReceived
            }
        }
        delete finalForm.stageName
        delete finalForm.netInrReceived

        let cleanFinalForm = cleanObject(finalForm);

        updateTransactionRes(cleanFinalForm, transactionId)
            .then(res => {
                notify.success("Updated the transaction data!");
                setShowLoader(false);
                navigate(-1)
            })
            .catch(() => {
                notify.error("Not able to update the transaction");
                setShowLoader(false);
            })

    }

    const selectSearchData = (e, elemName, elemId) => {
        if (elemId === "currencyCode") {
          setUpdateForm({ ...updateForm, [elemId]: `${e}` });
        } else if (elemId === "purposeCode") {
          setUpdateForm({
            ...updateForm,
            purposeCode: e.value,
          });
        } else {
          setUpdateForm({ ...updateForm, [elemName]: e.name, [elemId]: `${e.id}` });
        }
      };

      const mapToFunc = async (res) => {
        let copyUpdateForm = updateForm;
        if (res.assignedOpsMember) {
          copyUpdateForm.opsMemberAssigned = res.assignedOpsMember;
          copyUpdateForm.assignedOpsMemberId = `${res.assignedOpsMemberId}`;
        }
        if (res.currencyCode) {
          copyUpdateForm.currencyCode = res.currencyCode;
        }
        if (res.amount) {
          copyUpdateForm.amount = res.amount;
        }
        if (res.miscellaneousCharges) {
          copyUpdateForm.commissionCharges = res.miscellaneousCharges;
        }
        if (res.stage) {
          copyUpdateForm.stageName = res.stage;
        }
        if (res.utr) {
          copyUpdateForm.utr = res.utr;
        }
        if (res?.payout?.amount) {
          copyUpdateForm.netInrReceived = res?.payout?.amount;
        }
        if (res.gstAmount) {
          copyUpdateForm.gstAmount = res.gstAmount;
        }
        if(res.purposeCodeAsPerRBI) {
            copyUpdateForm.purposeCode = res.purposeCodeAsPerRBI;
        }
        if(res?.stageName) {
            copyUpdateForm.stageName = res.stageName
        }
        setUpdateForm(copyUpdateForm);
      };

      useEffect(() => {
        async function getTransactionDetail(transactionId) {
          setShowLoader(true);
          if (transactionId) {
            getTransactionsDetail(transactionId).then((res) => {
              orgDetailsFetch(res.organisationId);
              setTransactionDetail(res);
              mapToFunc(res);
              let flag = false;
              let list_ = [];
              res.stageList.forEach((elem) => {
                if (flag) {
                  list_.push(elem);
                  return;
                }
                if (elem.name === res.stage) {
                  flag = true;
                  return;
                }
              });
              setType(res.transactionType)
              setShowLoader(false);
            });
          } else {
            let url = window.location.pathname;
            url = url.split("/");
            url = url[2];
            setTransactionId(url);
            getTransactionDetail(url);
            setShowLoader(false);
          }
        }
        getTransactionDetail(transactionId);
        async function orgDetailsFetch(orgId) {
          await getOrgsDetails(orgId).then((res) => {
            if (res.adBankDetailList) {
              setAdBankdetails(res.adBankDetailList);
              res.adBankDetailList.map((item) => {
                if (item.isPrimaryAccount === true) {
                  setFundReqBank(item.bankName);
                }
              });
            } else {
              res.bankDetailList.map((item) => {
                if (item.isPrimaryAccount === true) {
                  setFundReqBank(item.bankName);
                }
              });
            }
          });
        }
      }, []);

      const hasSpecialCharacters = (value) => {
        const specialCharRegex = /[^a-zA-Z0-9\s]/g;
        return specialCharRegex.test(value);
      };

    return(
        <Box
            sx={{ padding: '1rem' }}
        >
            <Typography
                variant="h5"
                sx={{ paddingBottom: '1rem', fontWeight: 400 }}
            >
                Update Transaction - <b>{}</b>
            </Typography>
            { transactionDetail && (
                <Box
                    component="form"
                    noValidate
                    onSubmit={(e) => updateTransactionCall(e)}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={6} sx={{ paddingLeft: '0 !important' }}>
                    <Box
                        sx={{
                            border:"1px solid #a2a2a2",
                            borderRadius:"4px",
                            padding: '1rem',
                            height:'100%'
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                paddingBottom: '0.5rem',
                                color: '#4e4b4b',
                                borderBottom: '0.5px solid',
                                marginBottom: '1rem'
                            }}
                        >
                            Customer Details
                        </Typography>
                        <FormControl
                            readOnly
                            disabled
                            variant="standard"
                            sx={{ width: '300px', display: 'block', marginTop: '0.5rem' }}
                        >
                            <InputLabel htmlFor="name">Customer Name</InputLabel>
                            <Input
                                value={
                                    transactionDetail?.customerName
                                        ? transactionDetail.customerName
                                        : '-'
                                }
                                id="name"
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                        <FormControl
                            readOnly
                            disabled
                            variant="standard"
                            sx={{ width: '300px', display: 'block', marginTop: '0.5rem' }}
                        >
                            <InputLabel htmlFor="name">Initiation Date</InputLabel>
                            <Input
                                value={
                                    transactionDetail.initiationDate
                                        ? DateConvert(transactionDetail.initiationDate)
                                        : "-"
                                }
                                id="initiationDate"
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                        <FormControl
                            variant="standard"
                            readOnly
                            disabled
                            sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                        >
                            <InputLabel htmlFor="stageName">Current Stage</InputLabel>
                            <Input
                                id="stageName"
                                value={
                                    updateForm.stageName !== null ? updateForm.stageName : ""
                                }
                                sx={{ width: "100%" }}
                            />
                         </FormControl>
                         <FormControl
                            variant='standard'
                            sx={{
                                width:"300px",
                                display:"block",
                                marginTop:"0.5rem"
                            }}
                         >
                            <InputLabel htmlFor='nextStage' shrink>
                                New Stage
                            </InputLabel>
                            <NativeSelect
                                id="nextStage"
                                disabled={updateForm.stageName === "Dropped" || updateForm.stageName === "Completed"}
                                sx={{ padding: '0.4rem', width: '100%' }}
                                onChange={(e) => {
                                    if (e.target.value === "DROPPED") {
                                      setShowDroppedTxnModal(true);
                                      setUpdateForm({
                                        ...updateForm,
                                        nextStage: e.target.value,
                                      });
                                    } else {
                                      setShowDroppedTxnModal(false);
                                      setUpdateForm({
                                        ...updateForm,
                                        [e.target.id]:
                                          e.target.value === "" ? null : e.target.value,
                                      });
                                    }
                                  }}
                                value={
                                    updateForm?.nextStage !== null
                                    ? updateForm?.nextStage
                                    : ""
                                }
                            >
                                <option value={""}>--Select--</option>
                                {
                                    inwardStages?.map((stage,i) => {
                                        return(
                                            <option value={stage?.value} key={i}>
                                                {stage?.label}
                                            </option>
                                        )
                                    })
                                }
                            </NativeSelect>

                         </FormControl>
                         <SearchSelect
                            selectSearchData={selectSearchData}
                            label={"Ops Member Assigned"}
                            name={"opsMemberAssigned"}
                            id={"assignedOpsMemberId"}
                            value={
                                updateForm.opsMemberAssigned !== null
                                    ? updateForm.opsMemberAssigned
                                    : "-"
                            }
                         />
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={6}
                    sx={{ paddingRight: '0 !important' }}
                >
                    <Box
                        sx={{
                            border: '1px solid #a2a2a2',
                            borderRadius: '4px',
                            padding: '1rem',
                            height: '100%'
                        }}
                    >
                        <Typography
                            variant='h6'
                            sx={{
                                paddingBottom: '0.5rem',
                                color:'#4e4b4b',
                                borderBottom: '0.5px solid',
                                marginBottom: '1rem'
                            }}
                        >
                            Payer Details
                        </Typography>
                        <FormControl
                            variant='standard'
                            sx={{ width:'300px', display:'block', marginTop:'0.5rem' }}
                            disabled={true}
                        >
                            <InputLabel htmlFor="payerName">
                                Payer Name
                            </InputLabel>
                            <Input
                                id="payerName"
                                onChange={(e) => 
                                    setUpdateForm({
                                        ...updateForm,
                                        [e.target.id]:e.target.value
                                    })
                                }
                                value={
                                    transactionDetail?.partner?.legal_name
                                    ? transactionDetail?.partner?.legal_name
                                    : "-"
                                }
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                        <FormControl
                            variant='standard'
                            sx={{ width:'300px', display:'block', marginTop:'0.5rem' }}
                            disabled={true}
                        >
                            <InputLabel htmlFor="payerNickName">
                                Payer Nick Name
                            </InputLabel>
                            <Input
                                id="payerNickName"
                                onChange={(e) => 
                                    setUpdateForm({
                                        ...updateForm,
                                        [e.target.id]:e.target.value
                                    })
                                }
                                value={
                                    transactionDetail?.partner?.nickname
                                    ? transactionDetail?.partner?.nickname
                                    : "-"
                                }
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                        <FormControl
                            variant='standard'
                            sx={{ width:'300px', display:'block', marginTop:'0.5rem' }}
                            disabled={true}
                        >
                            <InputLabel htmlFor="payerNickName">
                                Payer Email
                            </InputLabel>
                            <Input
                                id="payerNickName"
                                onChange={(e) => 
                                    setUpdateForm({
                                        ...updateForm,
                                        [e.target.id]:e.target.value
                                    })
                                }
                                value={
                                    transactionDetail?.partner?.email
                                    ? transactionDetail?.partner?.email
                                    : "-"
                                }
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                    </Box>
                </Grid>
                </Grid>
                <Grid
                    container
                    spacing={2}
                    sx={{
                        border: '1px solid #a2a2a2',
                        borderRadius:'4px',
                        padding:'1rem',
                        marginTop:'1rem',
                        marginBottom:'4rem'
                    }}
                >
                    <Grid item xs={12} sx={{ padding: '0 !important' }}>
                        <Typography
                            variant='h6'
                            sx={{
                                paddingBottom:'0.5rem',
                                color:'#4e4b4b',
                                borderBottom:'0.5px solid',
                                marginBottom:'1rem'
                            }}
                        >
                            Transaction Details
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            variant='standard'
                            sx={{ width:'300px', display:'block', marginTop:'0.5rem' }}
                            disabled
                        >
                            <InputLabel htmlFor='amount'>Amount</InputLabel>
                            <Input
                                id="amount"
                                onChange={(e) =>
                                    setUpdateForm({
                                        ...updateForm,
                                        [e.target.id]:e.target.value
                                    })
                                }
                                value={transactionDetail?.invoice?.[0]?.amount ? transactionDetail?.invoice?.[0]?.amount : '-'}
                                sx={{ width:'100%' }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <SearchSelect
                            selectSearchData={selectSearchData}
                            label={"Currency"}
                            id={"currencyCode"}
                            value={
                                transactionDetail?.invoice?.[0]?.currency_code
                                ? transactionDetail?.invoice?.[0]?.currency_code
                                : '-'
                            }
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <SearchSelect
                            selectSearchData={selectSearchData}
                            label={"Purpose of Inward Transaction/Remittance"}
                            id={"purposeCode"}
                            value={
                                updateForm?.purposeCode &&
                                `${updateForm?.purposeCode}`
                            }
                            productType={"INWARD"}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            readOnly
                            disabled
                            variant="standard"
                            sx={{ width: '300px', display: 'block', marginTop: '0.5rem' }}
                        >
                            <InputLabel htmlFor="invoiceDate">Invoice Date</InputLabel>
                            <Input
                                value={
                                    transactionDetail?.invoice?.[0]?.invoice_date
                                        ? transactionDetail?.invoice?.[0]?.invoice_date
                                        : "-"
                                }
                                id="invoiceDate"
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            readOnly
                            variant="standard"
                            sx={{ width: '300px', display: 'block', marginTop: '0.5rem' }}
                            error={errors.netInr}
                        >
                            <InputLabel htmlFor="netInrReceived">Net INR Received</InputLabel>
                            <Input
                                onChange={(e) => {
                                    setUpdateForm({
                                        ...updateForm,
                                        [e.target.id]:e.target.value
                                    })

                                    if(!onlyNumericDigitsWithDecimalRegex.test(e.target.value) || (e.target.value && e.target.value.length > 100)){
                                        setErrors((errors) => ({
                                          ...errors,
                                          netInr:true
                                        }))
                                      } else {
                                        setErrors((errors) => ({
                                          ...errors,
                                          netInr:false
                                        }))
                                      }
                                }
                                }
                                value={
                                    updateForm?.netInrReceived
                                        ? updateForm.netInrReceived
                                        : ""
                                }
                                id="netInrReceived"
                                sx={{ width: '100%' }}
                            />
                            {errors.netInr && <FormHelperText>Please enter proper value!</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            variant="standard"
                            sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                            error={errors.utr}
                        >
                            <InputLabel htmlFor="utr">UTR</InputLabel>
                            <Input
                            id="utr"
                            onChange={(e) => {
                            setUpdateForm({
                            ...updateForm,
                            [e.target.id]: e.target.value,
                            })

                            if(hasSpecialCharacters(e.target.value) || !utrRegex.test(e.target.value)){
                                setErrors((errors) => ({
                                  ...errors,
                                  utr:true
                                }))
                              } else {
                                setErrors((errors) => ({
                                  ...errors,
                                  utr:false
                                }))
                              }
                            }
                        }
                            value={updateForm.utr ? updateForm.utr : ""}
                            sx={{ width: "100%" }}
                            />
                            {errors.utr && <FormHelperText>Please enter proper value!</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            variant="standard"
                            sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                            error={!!errors.gstAmount}
                        >
                            <InputLabel htmlFor="gstAmount">GST Charges</InputLabel>
                            <Input
                            id="gstAmount"
                            onChange={(e) => {
                            setUpdateForm({
                            ...updateForm,
                            [e.target.id]: e.target.value,
                            })

                            if(!onlyNumericDigitsWithDecimalRegex.test(e.target.value) || (e.target.value && e.target.value.length > 100)){
                                setErrors((errors) => ({
                                  ...errors,
                                  gstAmount:true
                                }))
                              } else {
                                setErrors((errors) => ({
                                  ...errors,
                                  gstAmount:false
                                }))
                              }
                            }
                        }
                            value={updateForm.gstAmount ? updateForm.gstAmount : ""}
                            sx={{ width: "100%" }}
                            />
                            {errors.gstAmount && <FormHelperText>Please enter proper value!</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            variant="standard"
                            sx={{ width: "300px", display: "block", marginTop: ".5rem" }}
                            error={errors.commissionCharges}
                        >
                            <InputLabel htmlFor="commissionCharges">Commission Charges</InputLabel>
                            <Input
                            id="commissionCharges"
                            onChange={(e) => {
                            setUpdateForm({
                            ...updateForm,
                            [e.target.id]: e.target.value,
                            })

                            if(!onlyNumericDigitsWithDecimalRegex.test(e.target.value) || (e.target.value && e.target.value.length > 100)){
                                setErrors((errors) => ({
                                  ...errors,
                                  commissionCharges:true
                                }))
                              } else {
                                setErrors((errors) => ({
                                  ...errors,
                                  commissionCharges:false
                                }))
                              }
                            }
                        }
                            value={updateForm.commissionCharges ? updateForm.commissionCharges : ""}
                            sx={{ width: "100%" }}
                            />
                            {errors.commissionCharges && <FormHelperText>Please enter proper value!</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            readOnly
                            disabled
                            variant="standard"
                            sx={{ width: '300px', display: 'block', marginTop: '0.5rem' }}
                        >
                            <InputLabel htmlFor="dueDate">Due Date</InputLabel>
                            <Input
                                value={
                                    transactionDetail?.invoice?.[0]?.due_date_of_payment
                                        ? transactionDetail?.invoice?.[0]?.due_date_of_payment
                                        : "-"
                                }
                                id="dueDate"
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            readOnly
                            disabled
                            variant="standard"
                            sx={{ width: '300px', display: 'block', marginTop: '0.5rem' }}
                        >
                            <InputLabel htmlFor="invoiceNumber">Invoice Number</InputLabel>
                            <Input
                                value={
                                    transactionDetail?.invoice?.[0]?.reference_number
                                        ? transactionDetail?.invoice?.[0]?.reference_number
                                        : "-"
                                }
                                id="invoiceNumber"
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            readOnly
                            disabled
                            variant="standard"
                            sx={{ width: '300px', display: 'block', marginTop: '0.5rem' }}
                        >
                            <InputLabel htmlFor="transactionType">Transaction Type</InputLabel>
                            <Input
                                value={
                                    transactionDetail?.transactionType
                                        ? (transactionDetail.transactionType)
                                        : "-"
                                }
                                id="transactionType"
                                sx={{ width: '100%' }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl
                            variant="standard"
                            sx={{ width: "300px", display: "block", marginTop: "1rem" }}
                        >
                            <TransactionFileUpload transactionId={transactionId} productType="INWARD"/>
                        </FormControl>
                    </Grid>
                </Grid>
                <Box
            sx={{
              position: "fixed",
              bottom: "0",
              right: "0",
              width: "100%",
              bgcolor: "#fff",
              borderTop: "1px solid #f2f2f2",
              padding: "1rem",
              textAlign: "right",
            }}
          >
            <DroppedStage
              setShowDroppedTxnModal={setShowDroppedTxnModal}
              showDroppedTxnModal={showDroppedTxnModal}
              setUpdateForm={setUpdateForm}
              updateForm={updateForm}
              transactionId={transactionId}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={updateForm.stageName === "CANCELLED" ? true : false}
            >
              Update Transaction
            </Button>
            </Box>
                
              </Box>
            ) }

        </Box>
    )
}

export default UpdateInwardTransaction;